import PropTypes from 'prop-types';

export const AutomationRule = PropTypes.shape({
  automationRuleId: PropTypes.string,
  name: PropTypes.string,
  createdDate: PropTypes.string,
  active: PropTypes.bool.isRequired,
  order: PropTypes.number,
  filterId: PropTypes.string,
});
